import React from 'react';
import {useSelector} from 'react-redux';

import {hooks} from '../hooks';
import {RootState} from '../store';
import {Screens} from '../enums';

import {setScreen} from '../store/slices/tabSlice';

type FooterIcon = 'home' | 'services' | 'phone' | 'map' | 'instagram';

const tabs = [
  {
    id: 1,
    screen: Screens.Home,
    label: 'Ana Sayfa',
    icon: 'home' as FooterIcon,
  },
  {
    id: 2,
    screen: Screens.Search,
    label: 'Hizmetler',
    icon: 'services' as FooterIcon,
  },
  {
    id: 3,
    screen: Screens.Cart,
    label: 'Ara',
    icon: 'phone' as FooterIcon,
  },
  {
    id: 4,
    screen: Screens.Wishlist,
    label: 'Konum',
    icon: 'map' as FooterIcon,
  },
  {
    id: 5,
    screen: Screens.Profile,
    label: 'Instagram',
    icon: 'instagram' as FooterIcon,
  },
];

export const Footer: React.FC = () => {
  const dispatch = hooks.useDispatch();

  const curentScreen = useSelector((state: RootState) => state.tabSlice.screen);
  const renderIcon = (icon: FooterIcon, active: boolean): JSX.Element => {
    const stroke = active ? 'var(--main-color)' : 'var(--text-color)';
    const fill = active ? 'rgba(208, 82, 120, 0.16)' : 'transparent';

    if (icon === 'home') {
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          aria-hidden='true'
        >
          <path
            d='M4 10.8 12 4l8 6.8v7.7a1.5 1.5 0 0 1-1.5 1.5h-4.2v-5.4H9.7V20H5.5A1.5 1.5 0 0 1 4 18.5v-7.7Z'
            fill={fill}
            stroke={stroke}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.6'
          />
        </svg>
      );
    }

    if (icon === 'services') {
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          aria-hidden='true'
        >
          <path
            d='M5 5h5v5H5V5Zm9 0h5v5h-5V5ZM5 14h5v5H5v-5Zm9 0h5v5h-5v-5Z'
            fill={fill}
            stroke={stroke}
            strokeLinejoin='round'
            strokeWidth='1.6'
          />
        </svg>
      );
    }

    if (icon === 'phone') {
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          aria-hidden='true'
        >
          <path
            d='M8.4 5.4 10 8.8l-1.5 1.4c.8 1.8 2.3 3.3 4.1 4.1L14 12.8l3.4 1.6v3.2c0 .7-.6 1.3-1.3 1.3C9.9 18.9 5 14 5 7.9c0-.8.6-1.4 1.3-1.4h2.1Z'
            fill={fill}
            stroke={stroke}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.6'
          />
        </svg>
      );
    }

    if (icon === 'map') {
      return (
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          aria-hidden='true'
        >
          <path
            d='M12 21s6-5.1 6-10.5A6 6 0 1 0 6 10.5C6 15.9 12 21 12 21Z'
            fill={fill}
            stroke={stroke}
            strokeLinejoin='round'
            strokeWidth='1.6'
          />
          <path
            d='M12 12.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
            stroke={stroke}
            strokeWidth='1.6'
          />
        </svg>
      );
    }

    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        aria-hidden='true'
      >
        <rect
          width='14'
          height='14'
          x='5'
          y='5'
          fill={fill}
          stroke={stroke}
          strokeWidth='1.6'
          rx='4'
        />
        <path
          d='M15.5 8.5h.01M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z'
          stroke={stroke}
          strokeLinecap='round'
          strokeWidth='1.6'
        />
      </svg>
    );
  };

  return (
    <footer
      className='salon-footer'
    >
      <ul className='salon-footer__list'>
        {tabs.map((tab) => {
          const active = curentScreen === tab.screen;

          return (
            <li
              key={tab.id}
            >
              <button
                className={`salon-footer__button${active ? ' is-active' : ''}`}
                onClick={() => dispatch(setScreen(tab.screen))}
                type='button'
              >
                {renderIcon(tab.icon, active)}
                <span>{tab.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </footer>
  );
};
